/**
 * Create common API
 */

import axios from 'axios';;
import { ATTRIBUTE_APPLICATION_ID } from '../helpers/constant';

function veritoneApi(baseUrl, token) {
    let header = {}
    if (token) {
        header = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        }
    } else {
        header = {
            "Content-Type": "application/json",
        }
    }
    header['x-veritone-application'] = ATTRIBUTE_APPLICATION_ID;
    return axios.create({
        baseURL: baseUrl,
        headers: header,
        withCredentials: true
    })
}

export default veritoneApi;